import React from "react";
import {Typography, Box, IconButton} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import {Link} from "react-router";
import {Definition} from "common/flowmaster/types/data_asset";
import {OrganisationId} from "common/types/organisation";
import DefinitionSelector from "common_components/flowmaster/data_asset/definition_selector";

const styles = {
  selectContainer: {
    display: "flex",
    alignItems: "flex-end",
    gap: ".5em",
  },
  formControl: {
    minWidth: "25em",
    width: "auto",
    flexShrink: 0,
  },
  container: {
    border: "1px solid #ddd",
    borderRadius: 4,
    padding: "1em",
    display: "flex",
    flexDirection: "column",
    gap: "1em",
    marginBottom: "1em",
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    height: "48px",
    fontWeight: "bold",
  },
  linkButton: {
    height: 56,
    width: 56,
    padding: 0,
  },
} as const;

interface DefinitionSectionProps {
  definitions: Definition[];
  selectedDefinitionId: number | null;
  handleDefinitionChange: (definitionId: number) => void;
  organisationId: OrganisationId;
}

const DefinitionSection: React.FC<DefinitionSectionProps> = ({
  definitions,
  selectedDefinitionId,
  handleDefinitionChange,
  organisationId,
}) => {
  const hasSelectedDefinition = Boolean(selectedDefinitionId);

  return (
    <Box style={styles.container}>
      <Typography variant="body1" style={styles.sectionLabel}>
        Definitions
      </Typography>

      <div style={styles.selectContainer}>
        <DefinitionSelector
          definitions={definitions}
          selectedDefinitionId={selectedDefinitionId}
          handleDefinitionChange={handleDefinitionChange}
          organisationId={organisationId}
          formControlStyles={styles.formControl}
        />
        {hasSelectedDefinition && (
          <Link
            to={`/organisation/${organisationId}/workflow/${selectedDefinitionId}/detail`}
          >
            <IconButton
              size="small"
              style={styles.linkButton}
              aria-label="link to definition"
            >
              <LinkIcon />
            </IconButton>
          </Link>
        )}
      </div>
    </Box>
  );
};

export default DefinitionSection;
